import { createContext } from "react";

const recordedExperimentViews = new Set();

export const GrowthBookAuthReadyContext = createContext(false);

export function getGrowthBookExperimentViewDedupeKey(experimentKey, userId) {
  return `${experimentKey}:${userId}`;
}

export function shouldRecordGrowthBookExperimentView(experimentKey, userId) {
  if (!experimentKey || !userId) {
    return false;
  }

  const dedupeKey = getGrowthBookExperimentViewDedupeKey(experimentKey, userId);
  if (recordedExperimentViews.has(dedupeKey)) {
    return false;
  }

  recordedExperimentViews.add(dedupeKey);
  return true;
}

export function canEvaluateUserScopedGrowthBookExperiments(growthbook, userId, authReady = true) {
  return Boolean(growthbook && userId && authReady);
}

export function resetGrowthBookExperimentViewTracking() {
  recordedExperimentViews.clear();
}
